import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

export function stickNavbar() {
    //define navbar
    const navbar = document.getElementById('navbar');

    // define 1st timeline
    const tl = gsap.timeline( {
        scrollTrigger: {
            trigger: '.is-hero',
            start: 'top top',
            end: 'bottom bottom',
            toggleActions: 'play none none reverse',
            scrub: true,
            markers: false,
        }
    });

    tl.to(navbar, {
        position: 'fixed',
    })

    // define 2nd timeline to change the colour
    const tl2 = gsap.timeline( {
        scrollTrigger: {
            trigger: '.is-lets-talk',
            endTrigger: '.is-lets-talk',
            start: 'top+=100 top',
            end: 'bottom bottom',
            toggleActions: 'play none none reverse',
            scrub: true,
            markers: false,
        }
    });

    tl2.to(navbar, {
        backgroundColor: 'white'
    })
}